module.exports = __webpack_public_path__ + "static/canadian-tire-logo-64eeff53dd007b9a77b37018fa2ed113.png";